import type { BaseEntity } from './BaseEntity';

export interface Contact extends BaseEntity {
  name: string;
  email: string;
  phone: string;
}

type ValidationResult = { issues: { message: string; path: (keyof Contact)[] }[] };

export function validate(vendor: Partial<Contact>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!vendor.name) {
    issues = [...issues, { message: 'Name is required', path: ['name'] }];
  }

  if (!vendor.email) {
    issues = [...issues, { message: 'Email is required', path: ['email'] }];
  }

  if (!vendor.phone) {
    issues = [...issues, { message: 'Phone is required', path: ['phone'] }];
  }

  return { issues };
}